import { render, staticRenderFns } from "./ShopSubsidyRecord.vue?vue&type=template&id=82ddd1bc&scoped=true"
import script from "./ShopSubsidyRecord.vue?vue&type=script&lang=js"
export * from "./ShopSubsidyRecord.vue?vue&type=script&lang=js"
import style0 from "./ShopSubsidyRecord.vue?vue&type=style&index=0&id=82ddd1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ddd1bc",
  null
  
)

export default component.exports